import { ActionType } from '@/actions';
import { ActionSetDrawDays } from './interfaces';

export const setDrawDays = (
  game: number,
  days: string[]
): ActionSetDrawDays => {
  return {
    type: ActionType.DRAW_DAYS_SET,
    game,
    days,
  };
};
